import ForgotPasswordShell from "../../components/forgot-password-shell";

const ForgotPasswordPage = () => {
  return (
    <div className="flex h-screen justify-center items-center">
      <ForgotPasswordShell />
    </div>
  );
};

export default ForgotPasswordPage;
